var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitkiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7926 6.25003L14.7016 1.1521V37.5864L11.7926 42.2235V6.25003Z",
    fill: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3226 14.0265L20.2316 8.92859V45.3629L17.3226 50V14.0265Z",
    fill: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2834 14.0265L33.1924 8.92859V45.3629L30.2834 50V14.0265Z",
    fill: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1705 6.25003L44.0795 1.1521V37.5864L41.1705 42.2235V6.25003Z",
    fill: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0169 10.4217L43.9984 8.48688L34.6806 30.438L30.817 32.0952L40.0169 10.4217Z",
    fill: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7733 28.7219L31.8331 24.424L42.7447 45.628L41.5469 49.6578L30.7733 28.7219Z",
    fill: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9942 8.89978C8.6916 9.39903 2.08064 12.4482 2.0576 20.6509C2.0288 30.9044 10.6694 32.9781 11.9942 33.0645C13.0542 33.1337 13.9336 33.0933 14.2408 33.0645C17.6202 32.4789 24.3272 29.1763 24.1198 20.6509C23.9124 12.1256 17.217 9.26458 13.8952 8.89978H11.9942ZM4.39056 20.6509C4.34471 14.3145 9.44056 11.7512 11.9942 11.2615H14.2408C20.3929 12.3214 21.8733 17.9627 21.8445 20.6509C22.0749 27.5403 17.0442 30.2996 14.5 30.818H11.9942C9.22927 30.1556 4.44786 28.5715 4.39056 20.6509Z",
    fill: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3537 30.4436L25.5599 34.6486L25.5311 4.00346H17.6106L19.4539 0.0288086H37.0518L35.0933 4.00346H28.3537V30.4436Z",
    fill: "#EEF4FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1659,
    height: 50,
    fill: "white",
    transform: "translate(2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitkiLogo);
export default __webpack_public_path__ + "static/media/Fitki_logo.74c90a23.svg";
export { ForwardRef as ReactComponent };